import { Grid } from '@mui/material'
import { SPACES } from 'src/constants'

import { DailyAverageStatistic, TotalViewsStatistic } from './items-statistic'

interface IProps {
  timeframe: number
}

const GlobalStatistic = ({ timeframe }: IProps) => {
  return (
    <Grid
      container
      flexDirection={'row'}
      // justifyContent="space-between"
      justifyContent="flex-start"
      gap={SPACES.xxxxxl}
      display={'flex'}
    >
      <TotalViewsStatistic timeframe={timeframe} />
      <DailyAverageStatistic timeframe={timeframe} />
      {/* <SharesStatistic /> */}
    </Grid>
  )
}

export { GlobalStatistic }
